import { formatPrice } from './../../../../../vendor/rshop/frontend/assets/js/common/format';
import { replaceTranslate } from '../../../common/replaceTranslate';
import { thumbnail } from '../../../common/thumbnail';
import { Vue, i18n } from '../../../common/vue';
import BranchReservationStore from './_store';

const branchReservationEl = document.querySelector('.vue-branch-reservation')
const reservationBranchPickerEl = document.querySelector('#reservation-branch-map-pickup-el')
let hasInitializationStarted = false
let hasBranchPickerInitialized = false

// Initialize the reservation branch picker map component
if (reservationBranchPickerEl) {
    $('#reservation-branch-picker-modal').on('show.bs.modal', async () => {
        if (hasBranchPickerInitialized) {
            // Už je inicializovaný, nič nerobiť - onModalShown sa postará o fetch
            return;
        }
        hasBranchPickerInitialized = true;

        const { default: ReservationBranchPickupMap } = await import('./ReservationBranchPickupMap.vue');

        window.$_reservationBranchPicker = new Vue({
            i18n: i18n,
            render: (h) => h(ReservationBranchPickupMap)
        }).$mount(reservationBranchPickerEl);
        // onModalShown event sa postará o načítanie dát
    });

    // Restore body classes when branch picker closes if reservation modal is still open
    $('#reservation-branch-picker-modal').on('hidden.bs.modal', () => {
        const reservationModal = document.querySelector('#product-reservation')
        if (reservationModal && reservationModal.classList.contains('in')) {
            document.body.classList.add('modal-open', 'is-overlayed')
        }
    })
}

if (branchReservationEl) {
    $('#product-reservation').on('shown.bs.modal', () => {
        document.body.classList.add('modal-open')
    })

    $('#product-reservation').on('show.bs.modal', async () => {
        if (hasInitializationStarted) {
            return
        }
        hasInitializationStarted = true

        const authData = JSON.parse(branchReservationEl.dataset.authData)

        // Set auth data to local storage if it is empty
        if (authData.email && localStorage.getItem('reservation-email') === null) {
            localStorage.setItem('reservation-email', authData.email)
        }
        if (authData.phone && localStorage.getItem('reservation-phone') === null) {
            localStorage.setItem('reservation-phone', authData.phone)
        }

        // Remove auth data from local storage if the is no user
        if(!authData.email && localStorage.getItem('reservation-email') !== null){
            localStorage.removeItem('reservation-email');
        }
        if (!authData.phone && localStorage.getItem('reservation-phone') !== null) {
            localStorage.removeItem('reservation-phone')
        }

        const { default: BranchReservation } = await import('./Index')

        Vue.use({
            install(Vue) {
                Vue.prototype.replaceTranslate = replaceTranslate
                Vue.prototype.formatPrice = formatPrice
                Vue.prototype.thumbnail = thumbnail
            }
        })

        window.$_branchReservation = new Vue({
            i18n: i18n,
            store: BranchReservationStore,
            render: (h) => h(BranchReservation)
        }).$mount(branchReservationEl)

        BranchReservationStore.dispatch('retrieveCurrentReservation')
    })
}

for (const openModalEl of document.querySelectorAll('.js-open-modal-reservation')) {
    openModalEl.addEventListener('click', (event) => {
        event.preventDefault()

        BranchReservationStore.dispatch('retrieveCurrentReservation')
        $('#product-reservation').modal('show')
    })
}

// Listen for branch selection from the map picker
document.addEventListener('reservationBranchSelected', async (event) => {
    const { branch, pendingProductData, distance } = event.detail
    const pendingAction = window.pendingReservationAction

    // Handle branch change (from inside reservation modal)
    if (pendingAction?.type === 'changeBranch') {
        window.pendingReservationAction = null

        const { data: responseData } = await BranchReservationStore.dispatch('selectBranch', {
            branchId: branch.id,
            force: true,
            distance
        })

        Eshop.alert(responseData.message, {
            type: responseData.status ? 'success' : 'error',
            delay: responseData.status ? 4000 : 10000
        })

        await BranchReservationStore.dispatch('retrieveCurrentReservation')
        return
    }

    // Handle adding product with selected branch
    if (!pendingProductData || !pendingProductData.productId) {
        return
    }

    // Add the product to reservation with the selected branch
    const { data: responseData } = await BranchReservationStore.dispatch('addProductToReservation', {
        productId: pendingProductData.productId,
        branchId: branch.id,
        distance
    })

    Eshop.alert(responseData.message, {
        type: responseData.status ? 'success' : 'error',
        delay: responseData.status ? 4000 : 10000
    })

    // Retrieve current reservation data before opening modal
    await BranchReservationStore.dispatch('retrieveCurrentReservation')

    // Open the reservation modal
    $('#product-reservation').modal('show')
})

for (const addToReservationEl of document.querySelectorAll('.js-add-to-reservation')) {
    addToReservationEl.addEventListener('click', async (event) => {
        event.preventDefault()

        const { productId, productName, productVariant, productPrice, productImage } = addToReservationEl.dataset
        const productPreview = { productId, name: productName, variant: productVariant, price: productPrice, image: productImage }

        // Najprv načítať aktuálne dáta o rezervácii (ak ešte nie sú načítané)
        if (!BranchReservationStore.state.reservationData) {
            await BranchReservationStore.dispatch('retrieveCurrentReservation')
        }

        // Check if there's already a product in reservation
        const currentProducts = BranchReservationStore.state.reservationData?.products || []

        if (currentProducts.some((product) => product.product_id == productId)) {
            await BranchReservationStore.dispatch('retrieveCurrentReservation')
            $('#product-reservation').modal('show')
            return
        }

        if (currentProducts.length >= 1) {
            window.Eshop.confirm(
                i18n.t('BranchReservation.ReplaceProductPopup.title'),
                {
                    text: i18n.t('BranchReservation.ReplaceProductPopup.text'),
                    icon: false,
                    confirmButtonText: i18n.t('BranchReservation.ReplaceProductPopup.confirm'),
                    denyButtonText: i18n.t('BranchReservation.ReplaceProductPopup.cancel')
                },

                async () => {
                    const existingProduct = currentProducts[0]

                    await BranchReservationStore.dispatch('removeProductFromReservation', {
                        productId: existingProduct.product_id,
                    })

                    const branchPickerModal = document.querySelector('#reservation-branch-picker-modal')
                    if (branchPickerModal) {
                        window.pendingReservationProductData = productPreview
                        window.reservationBranchPicker?.resetSelection()
                        $('#reservation-branch-picker-modal').modal({
                            backdrop: 'static',
                            keyboard: false,
                            show: true
                        })
                    } else {
                        const { data: responseData } = await BranchReservationStore.dispatch('addProductToReservation', { productId })
                        Eshop.alert(responseData.message, {
                            type: responseData.status ? 'success' : 'error',
                            delay: responseData.status ? 4000 : 10000
                        })
                        $('#product-reservation').modal('show')
                    }
                }
            )
            return
        }

        // Check if branch picker modal exists - if so, open it first
        const branchPickerModal = document.querySelector('#reservation-branch-picker-modal')
        if (branchPickerModal) {
            // Store pending product data globally for after branch selection
            window.pendingReservationProductData = productPreview

            $('#reservation-branch-picker-modal').modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            })
            return
        }

        // Fallback: if no branch picker, use the old flow
        BranchReservationStore
            .dispatch('addProductToReservation', { productId })
            .then(({ data: responseData }) => {
                Eshop.alert(responseData.message, {
                    type: responseData.status ? 'success' : 'error',
                    delay: responseData.status ? 4000 : 10000
                })
            })

        $('#product-reservation').modal('show')
    })
}